<app-toast />
<app-navbar [class.hide]="isPaymentGatewayRoute" id="navbar" />
@if (showTestingEnvironmentAlert) {
  <div class="dev-site-alert">
    <p><span (click)="hideTestingEnvironmentAlert()">IMPORTANTE:</span> Este es un sitio de prueba, para ir a Mundo Hogar haz clic aquí: <a href="https://www.mundohogar.com.mx" class="link">www.mundohogar.com.mx</a></p>
  </div>
}
@if (shouldAskForCookiesAcceptance) {
  <div class="cookies-container-bar">
    <div class="cookies-container">
      <div class="cookies">
        <div class="title-container">
          <i class="icon-information-circle icon"></i>
          <h4 class="title">Este sitio utiliza cookies</h4>
        </div>
        <div class="content">
        <!-- TODO: Delete display hidden in link and add final pivot, when the link is available-->
          <p class="text">Utilizamos cookies propias y de terceros para obtener datos estadísticos de la navegación de nuestros usuarios y mejorar nuestros servicios.<a class="link" rel="noopener">Leer más información</a></p>
        </div>
      </div>
      <app-button innerId="btn-fNZsLeOG" class="button" label="Aceptar" (action)="acceptCookies()" />
    </div>
  </div>
} @else {
  <app-floating-interceptor [location]="url" />
}
<router-outlet />
<app-footer [class.hide]="isPaymentGatewayRoute" [url]="url" />
<app-alert-interceptor #alertInterceptor />
